import { Button, Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  nationality: string;
  title: string;
};

export const UnrefundedModal = ({
  isOpen,
  onClose,
  nationality,
  title,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '340px' }}
    >
      <Modal.Header>
        <HeaderContainer>
          <Icon.WarningFilled fillColor='#FF2D55' size={30} />
          {title}
        </HeaderContainer>
      </Modal.Header>
      <ModalBody>
        <p>
          {nationality === 'KOR'
            ? '세관 검사를 받지 않고 출국한 경우'
            : 'If you left without customs inspection,'}{' '}
          <Strong>
            {nationality === 'KOR'
              ? '영수증 지참 후 3개월 내에 한국에 재방문'
              : 'revisit Korea within 3 months with your receipts'}
          </Strong>{' '}
          {nationality === 'KOR' ? '하여 환급 받으세요.' : 'for a refund.'}
        </p>
        <Small>
          {nationality === 'KOR'
            ? '문의가 있을 경우 문의하기를 통해 메시지를 남겨주세요.'
            : 'If you have any questions, please leave a message via Inquiry.'}
        </Small>
      </ModalBody>
      <Modal.Footer>
        <Button
          type='button'
          onClick={onClose}
          style={{ backgroundColor: '#030303' }}
        >
          {nationality === 'KOR' ? '확인' : 'Confirm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  text-align: center;
  line-height: 150%;
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  text-align: center;
  margin-top: 20px;
  border-radius: 6px;
  background: #f4f4f4;
  line-height: 150%;
`;

const Strong = styled.strong`
  color: #ed0828;
`;

const Small = styled.small`
  color: #999;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.24px;
`;
